const collectionDetailsTitles = {
  animated: 'Animated',
  rigged: 'Rigged',
  lowPoly: 'Low Poly',
  pbr: 'PBR',
  simulationReady: 'Simulation-ready',
}

export function getProvidedByDesignerDetails(details, summaryFileExtensions, isCollection) {
  if (!isCollection) {
    return details
  }

  return Object.entries(summaryFileExtensions).reduce((acc, [key, value]) => {
    if (collectionDetailsTitles[key]) {
      acc.push({ title: collectionDetailsTitles[key], value })
    }

    return acc
  }, [])
}
